import {AfterViewChecked, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {ReportsPagerService} from './pager.service';
import {ReportsService} from './reports.service';
import {ActivateService} from '../activate/activate.service';
import {NotifierService} from "../notifier/notifier.service";
import {NotificationType} from "../notifier/notification-type.enum";
import {Set} from "../../model/set";
import {BackendServiceResponse} from "../../model/backend-service-response";
import {Observable} from "rxjs";
import {Report} from "../../model/report";
import {forkJoin} from "rxjs/observable/forkJoin";
import {CommonService} from "../../common/common.service";
import {Dictionary} from "../../model/dictionary";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {PublicationType} from "./publication-type.enum";
import {CreateSetStep} from "../sets/create-set-step.enum";
import {SetService} from "../sets/set.service";
import {HeaderService} from "../header/header.service";
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";
import {Group} from "../../model/group";
import {Pager} from "../../model/pager";
import {HttpParams} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'pbc-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit, AfterViewChecked {
    pager: Pager;

    pagedItems: any[];

    reportData: any[];

    //Potencjalna liczba raportow zwracana przez serwis - uzywane do utworzenia pagera
    private reportsCount : number

    countList: Array<any> = [];

    filter: boolean = false;

    dateInputFlagFrom: boolean;

    dateInputFlagTo: boolean;

    discProduct: any[];

    discProductSelected: Array<any> = [];

    dictInstitution: any[];

    dictInstitutionSelected: Array<any> = [];

    dictClientGroup: any[];

    dictClientGroupSelected: Array<any> = [];

    dictInterestArea: any[];

    dictInterestAreaSelected: Array<any> = [];

    dictPublicationFrequency: any[];

    dictPublicationFrequencySelected: Array<any> = [];

    publishedSelected : boolean = false;
    notPublishedSelected : boolean = false;
    setsToFilter : Array<Set> = [];
    setsToFilterSelected : Array<number> = [];
    contentTypeSelected : Array<number> = [];

  @ViewChild('setName') setNameField : ElementRef;
  ngAfterViewChecked(): void {
    if (this.setNameField)
      this.setNameField.nativeElement.focus();
  }

    private setsToAssignToReport : Array<Set> = [];
    private setsToAssignToReportSelected : Array<Set> = [];

    showEditReportPopup : boolean = false;
    private contentTypeToAssign : Array<Dictionary> = [];
    private contentTypeToAssignSelected : number = null;
    private contentTypeToAssignToSetSelected : Array<number> = [];
    private showContentTypeSection : boolean = false;
    private productsToAssign : Array<Dictionary> = [];
    private productsToAssignSelected : Array<number> = [];
    private groupsToAssign : Array<Group> = [];
    private groupsToAssignSelected : Array<number> = [];
    private showGroupsSection : boolean = false;
    private showProductsSection : boolean = false;
    private institutionsToAssign : Array<Dictionary> = [];
    private institutionsToAssignToSet : Array<Dictionary> = [];
    private institutionsToAssignSelected : Array<number> = [];
    private showInstitutionsSection : boolean = false;
    private clientGroupsToAssign : Array<Dictionary> = [];
    private clientGroupsToAssignSelected : Array<number> = [];
    private showClientGroupsSection : boolean = false;
    private areaToAssign : Array<Dictionary> = [];
    private areaToAssignSelected : Array<number> = [];
    private showAreaSection : boolean = false;
    private frequencyToAssignSelected : Array<number> = [];
    private frequencyToAssign: Array<Dictionary> = [];
    private showFrequencySection : boolean = false;
    private reportToEdit : Report;
    private showCancelPublish : boolean = false;

    //Sortowanie
    orderByField : string = "publishFrom";
    orderAsc : boolean =  false;
    reportsAreFiltered : boolean = false;

    private static pageSize : number = 10;
    private currentPage : number = 1;

    //Publikacja
    publicationType : PublicationType = PublicationType.PUBLISH_IMMEDIATE;

    showPublish : boolean = false;
    private reportToPublish : Report;
    private publicationTypeEnum = PublicationType;
    private publishFrom : any = null;
    private showPublishFrom : boolean = false;

    editReportForm : FormGroup;

    fileFormatForFilter: Array<string> = [];

    fileFormatSelectedData: Array<any> = [];

    formData: FormData = new FormData();

    dateFrom: any;

    dateTo: any;

    filterObj = {
      dateFrom : null,
      dateTo : null,
      pageSize : ReportsComponent.pageSize,
      pageNumber : this.currentPage,
      fileFormat : [],
      thematics_products : [],
      thematics_institution : [],
      thematics_area : [],
      thematics_client_groups : [],
      thematics_frequency : [],
      content_type : [],
      published : false,
      notPublished  : false,
      set : []
    };

    filteredReportCount: number;

    isDelete: boolean;

    selectedReports: Array<Report> = [];

    deleteReport: boolean;

    addingFiles: boolean;

    deleteReportObj: any = undefined;

    singleReportDelete: boolean;

    showAddToSetPopup : boolean = false;

    demoDisabled: boolean = false;

    //Tworzenie zestawu z poziomu listy raportow
    currentCreateStep : CreateSetStep = null;
    private createSetForm : FormGroup;
    private setsToAssignToReportMoreLess : Array<Set> = [];
    private setsToAssignReportsVisibility : boolean = false;
    private readonly MORE_LESS_LIMIT : number = 6;
    private reportIdsToAssignToSetSelected : Array<number> = [];
    private setNameForDisplayOnStepTwo : string;
    private reportsToAssignToSets : Array<Report> = [];
    createSetStepEnum = CreateSetStep;

    @ViewChildren("fileFormatData") fileFormatData: QueryList<ElementRef>;
    @ViewChildren("products") products: QueryList<ElementRef>;
    @ViewChildren("institution") institution: QueryList<ElementRef>;
    @ViewChildren("intrstArea") intrstArea: QueryList<ElementRef>;
    @ViewChildren("clientGrp") clientGrp: QueryList<ElementRef>;
    @ViewChildren("frequency") frequency: QueryList<ElementRef>;
    @ViewChildren("headerCheckbox") headerCheckbox: QueryList<ElementRef>;
    @ViewChildren("contentTypes") contentTypes : QueryList<ElementRef>;
    @ViewChildren("published") published : QueryList<ElementRef>;
    @ViewChildren("notPublished") notPublished : QueryList<ElementRef>;
    @ViewChildren("sets") sets : QueryList<ElementRef>;

    constructor(private pagerService: ReportsPagerService, private reportService: ReportsService,
                private activateService: ActivateService, private notifierService: NotifierService,
                private setService : SetService,
                private headerService : HeaderService,
                private commonService : CommonService,
                private breadCrumbsService : BreadcumbsService,
                private activatedRoute : ActivatedRoute
                ) {
      this.createSetForm = new FormGroup({
        'setName': new FormControl('', [Validators.required])
      });
    }

    ngOnInit(): void {
      setTimeout(()=>this.breadCrumbsService.setSubfolder.emit("Raporty"),100);

      this.headerService.hideLoginRegisterButtons();
      this.pager = this.pagerService.getPager(0,1,ReportsComponent.pageSize);

      this.getCount().then(
        reportCount => {
          this.reportsCount = reportCount;
          this.filterRecords(true);
          this.pager = this.pagerService.getPager(reportCount,1,ReportsComponent.pageSize);
        },
        error => {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Bład w trakcie pobierania danych');
          console.error(error);
        }
      )

      this.activatedRoute.params.subscribe(
        queryParams => {
          const refresh = queryParams['refresh'];
          if (refresh > 0)
            this.clearForm();
        }
      )

      this.activateService.getDictProduct().subscribe(res => {
          this.discProduct = res;
      });
      this.activateService.getDictInstitution().subscribe(res => {
          this.dictInstitution = res;
      });
      this.activateService.getDictClient().subscribe(res => {
          this.dictClientGroup = res;
      });
      this.activateService.getDictInterestArea().subscribe(res => {
          this.dictInterestArea = res;
      });
      this.activateService.getDictPublicationFrequency().subscribe(res => {
          this.dictPublicationFrequency = res;
      });
      this.commonService.getSetList('name').subscribe(
        response => {
          if (response.status !== 1) {
            console.log(response);
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych');
          } else {
            this.setsToFilter = response.record;
          }
        },
        error => {
          console.error(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych');
        }
      )
      this.reportService.getFileFormats().subscribe(
        result => {
          this.fileFormatForFilter = result;
        },
        error => {
          console.error(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych');
        }
      )

      this.getDictionaries();
    }


    disableDemo(event) {
        if(event.target){
            if (event.target.checked) {
              for (let i = 0; i < this.groupsToAssign.length; i++)
                if (this.groupsToAssignSelected.indexOf(this.groupsToAssign[i].id) === -1)
                  this.groupsToAssignSelected.push(this.groupsToAssign[i].id);
            }
            else
                this.groupsToAssignSelected.splice(0, this.groupsToAssignSelected.length);

            this.demoDisabled = event.target.checked;
        }
    }

    setPage(page: number) {
      this.currentPage = page;

      this.getCount().then(
        reportsCount => {
          this.reportsCount = reportsCount;
          this.filterObj.pageSize = ReportsComponent.pageSize;
          this.filterObj.pageNumber = page;

          this.filterRecords(false);
          this.pager = this.pagerService.getPager(this.reportsCount, page, ReportsComponent.pageSize);
        },
        error => {
          console.error(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych');
        }
      )
    }

    hidePopup(): void {
        this.filter = false;
        // this.clearForm();
        this.deleteReport = false;
        this.deleteReportObj = undefined;
        this.singleReportDelete = false;
    }

    filterWithDateFrom(event : any) : void {
      const dateFrom = this.dateFrom ? new Date(this.dateFrom.year, this.dateFrom.month - 1, this.dateFrom.day).toUTCString() : null;
      if (dateFrom) {
        this.filterObj['dateFrom'] = dateFrom;
        this.filterRecordsAndGetCount();
      }
    }

    filterWithDateTo(event : any) : void {
      const dateTo = this.dateTo ? new Date(this.dateTo.year, this.dateTo.month - 1, this.dateTo.day).toUTCString() : null;
      if (dateTo) {
        this.filterObj['dateTo'] = dateTo;
        this.filterRecordsAndGetCount();
      }
    }

    filterWithDate(event: any): void {
        const dateFrom = this.dateFrom ? new Date(this.dateFrom.year, this.dateFrom.month - 1, this.dateFrom.day) : null;
        const dateTo = this.dateTo ? new Date(this.dateTo.year, this.dateTo.month - 1, this.dateTo.day) : null;
        if (dateTo)
          this.filterObj['dateFrom'] = dateFrom;
        if (dateTo)
          this.filterObj['dateTo'] = dateTo;
        if (dateTo && dateFrom) {
            this.filterObj['dateFrom'] = dateFrom;
            this.filterObj['dateTo'] = dateTo;
            this.filterRecordsAndGetCount();
        }
    }

    openFilterPopup() {
        this.filter = true;
    }

    getReportCountByFilter(event: any, id: any, key: string): void {

      if (key === 'fileFormat') {
          let position = this.fileFormatSelectedData.indexOf(id);
          if (position === -1)
            this.fileFormatSelectedData.push(id);
          else
            this.fileFormatSelectedData.splice(id, 1);

          this.filterObj[key] = this.fileFormatSelectedData;
          this.filterRecordsAndGetCount();
      } else if (key === 'thematics_products') {
          let position = this.discProductSelected.indexOf(id);
          if (position === -1)
            this.discProductSelected.push(id);
          else
            this.discProductSelected.splice(position, 1);

          this.filterObj[key] = this.discProductSelected;
          this.filterRecordsAndGetCount();
      }
      else if (key === 'thematics_institution') {
          let position = this.dictInstitutionSelected.indexOf(id);
          if (position === -1)
            this.dictInstitutionSelected.push(id);
          else
            this.dictInstitutionSelected.splice(position, 1);

          this.filterObj[key] = this.dictInstitutionSelected;
          this.filterRecordsAndGetCount();
      }
      else if (key === 'thematics_area') {
          let position = this.dictInterestAreaSelected.indexOf(id);
          if (position === -1)
            this.dictInterestAreaSelected.push(id);
          else
            this.dictInterestAreaSelected.splice(position, 1);

          this.filterObj[key] = this.dictInterestAreaSelected;
          this.filterRecordsAndGetCount();
      }
      else if (key === 'thematics_client_groups') {
          let position = this.dictClientGroupSelected.indexOf(id);
          if (position === -1)
            this.dictClientGroupSelected.push(id);
          else
            this.dictClientGroupSelected.splice(position, 1);

          this.filterObj[key] = this.dictClientGroupSelected;
          this.filterRecordsAndGetCount();
      }
      else if (key === 'thematics_frequency') {
          let position = this.dictPublicationFrequencySelected.indexOf(id);
          if (position == -1)
            this.dictPublicationFrequencySelected.push(id);
          else
            this.dictPublicationFrequencySelected.splice(position, 1)
          this.filterObj[key] = this.dictPublicationFrequencySelected;
          this.filterRecordsAndGetCount();
      } else if (key === 'published') {
        this.filterObj[key] = !this.filterObj[key];
        this.filterRecordsAndGetCount();
      } else if ( key === 'notPublished') {
        this.filterObj[key] = !this.filterObj[key];
        this.filterRecordsAndGetCount();
      } else if (key === 'set') {
        let position = this.setsToFilterSelected.indexOf(id);
        if (position == -1)
          this.setsToFilterSelected.push(id);
        else
          this.setsToFilterSelected.splice(position, 1);
        this.filterObj['set'] = this.setsToFilterSelected;
        this.filterRecordsAndGetCount();
      } else if (key === 'content_type') {
        let position = this.contentTypeSelected.indexOf(id);
        if (position === -1)
          this.contentTypeSelected.push(id);
        else
          this.contentTypeSelected.splice(position, 1);
        this.filterObj['content_type'] = this.contentTypeSelected;
        this.filterRecordsAndGetCount();
      }
    }

    filterRecordsAndGetCount(): void {
        this.getCount().then(
          count => {
            this.filteredReportCount = count;
          },
          error => {
            console.error(error);
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych');
          }
        );
    }

  /**
   * Zwraca ogólną liczbę raportów na podstawie filtra;
   * @param filterObject
   */
  getCount() : Promise<number> {
      return new Promise<number>((resolve, reject)=>{
        this.reportService.getCount(this.createFilterForRequest(this.filterObj)).subscribe(
          response => {
            if (response.status == 1)
              resolve(response.record);
            else  {
              reject(response);
            }
          },
          error => {
            reject(error);
          }
        )
      });
    }

    private createFilterForRequest(filterObject : any) : HttpParams {
      let httpParams : HttpParams = new  HttpParams();

      if (filterObject.dateFrom)
        httpParams = httpParams.set('dateFrom', filterObject.dateFrom);
      if (filterObject.dateTo)
        httpParams = httpParams.set('dateTo', filterObject.dateTo);
      if (filterObject.fileFormat.length > 0)
        httpParams = httpParams.set('fileFormat',filterObject.fileFormat);
      if (filterObject.thematics_frequency.length > 0)
        httpParams = httpParams.set('thematics_frequency',filterObject.thematics_frequency);
      if (filterObject.thematics_client_groups.length > 0)
        httpParams = httpParams.set('thematics_client_groups', filterObject.thematics_client_groups);
      if (filterObject.thematics_area.length > 0)
        httpParams = httpParams.set('thematics_area', filterObject.thematics_area);
      if (filterObject.thematics_institution.length > 0)
        httpParams = httpParams.set('thematics_institution', filterObject.thematics_institution);
      if (filterObject.thematics_products.length > 0)
        httpParams = httpParams.set('thematics_products', filterObject.thematics_products);
      if (filterObject.pageNumber)
        httpParams = httpParams.set('pageNumber', filterObject.pageNumber);
      if (filterObject.pageSize)
        httpParams = httpParams.set('pageSize', filterObject.pageSize);
      if (filterObject.published)
        httpParams = httpParams.set('published', filterObject.published);
      if (filterObject.notPublished)
        httpParams = httpParams.set('notPublished', filterObject.notPublished);
      if (filterObject.content_type)
        httpParams = httpParams.set('content_type', filterObject.content_type);
      if (filterObject.set)
        httpParams = httpParams.set('sets', filterObject.set);

      httpParams = httpParams.set('sortString', this.createSortString());

      return httpParams;
    }

    filterRecordsClick() : void {
      this.getCount().then(
        count => {
          this.filterObj.pageNumber = 1;
          this.currentPage = 1;
          this.filterRecords(false);
          this.pager = this.pagerService.getPager(count, 1, ReportsComponent.pageSize);
        },
        error => {
          console.error(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych');
        }
      )
    }

    filterRecords(clean? : boolean): void {
        this.reportService.getReportList(this.createFilterForRequest(this.filterObj)).subscribe(res => {
            this.reportData = res.record;
            this.reportData = this.reportData.map(response => {
                response.isOpen = false;
                this.selectedReports = [];
                this.isDelete = false;
                return response;
            });
            this.reportsAreFiltered = !clean;
            this.filter = false;
        });
        this.selectedReports = [];
    }

    clearForm(): void {
        this.dateFrom = null;
        this.dateTo = null;
        this.fileFormatData.forEach((element) => {
            element.nativeElement.checked = false;
        });
        this.products.forEach((element) => {
            element.nativeElement.checked = false;
        });
        this.institution.forEach((element) => {
            element.nativeElement.checked = false;
        });
        this.intrstArea.forEach((element) => {
            element.nativeElement.checked = false;
        });
        this.clientGrp.forEach((element) => {
            element.nativeElement.checked = false;
        });
        this.frequency.forEach((element) => {
            element.nativeElement.checked = false;
        });
        this.notPublished.forEach((element)=>{
            element.nativeElement.checked = false;
        })
        this.published.forEach((element) => {
          element.nativeElement.checked = false;
        });
        this.contentTypes.forEach((element) => {
          element.nativeElement.checked = false;
        });
        this.sets.forEach((element)=>{
          element.nativeElement.checked = false;
        })

        this.fileFormatSelectedData = [];
        this.discProductSelected = [];
        this.dictInstitutionSelected = [];
        this.dictPublicationFrequencySelected = [];
        this.dictInterestAreaSelected = [];
        this.dictClientGroupSelected = [];
        this.contentTypeSelected = [];
        this.setsToFilterSelected = [];
        this.publishedSelected = false;
        this.notPublishedSelected = false;
        this.filterObj = {
          dateFrom: null,
          dateTo: null,
          fileFormat : [],
          pageNumber: this.currentPage,
          pageSize:  ReportsComponent.pageSize,
          thematics_area: [],
          thematics_institution : [],
          thematics_client_groups: [],
          thematics_frequency: [],
          thematics_products: [],
          content_type: [],
          published : false,
          notPublished : false,
          set : []
        };
        this.getCount().then(
          count => {
            this.filterRecords(true);
            this.pager = this.pagerService.getPager(count,1, ReportsComponent.pageSize);
          },
          error => {
            console.error(error);
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych');
          }
        )
        this.filter = false;
        this.filteredReportCount = 0;
    }

    deleteRecordCount(key: any, event: any, report: any): void {
        if (event.target.checked) {
            this.isDelete = true;
            if (key === 'headerReport') {
                this.selectedReports = [];
                for (var i = 0; i < this.reportData.length; i++) {
                    this.selectedReports.push(this.reportData[i]);
                }
            }
            if (key === 'particularReport') {
                this.selectedReports.push(report);
                if (this.selectedReports.length === this.reportData.length) {
                    this.headerCheckbox.forEach((element) => {
                        element.nativeElement.checked = true;
                    });
                } else {
                }
            }
        }
        else {
            if (key === 'particularReport') {
                this.headerCheckbox.forEach((element) => {
                    element.nativeElement.checked = false;
                });
                this.selectedReports = this.selectedReports.filter((item) => item !== report);
            }
            if (key === 'headerReport') {
                this.isDelete = false;
                this.selectedReports = [];
            }
        }
        if (this.selectedReports.length === 0) {
            this.isDelete = false;
        }
    }
    deleteRecordData(): void {
        if (this.deleteReportObj != undefined) {
            this.selectedReports.push(this.deleteReportObj);
        }

        // this.reportService.deleteReports(this.singleReportDelete ? this.deleteReportObj.id : this.selectedReports.map(item => item.id)).subscribe(
        this.reportService.deleteReports(this.selectedReports.map(item => item.id)).subscribe(
            (response) => {
                this.isDelete = false;

                if (response.status == 1) {
                  const totalDeletedRecordCount = this.singleReportDelete ? '1' : this.selectedReports.length;

                  this.filterRecords();

                  if (this.selectedReports.length == 1)
                    this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                      "Raport ".concat(this.selectedReports[0].title, " został usunięte z systemu"));
                  else
                      this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                      "Raporty (".concat(totalDeletedRecordCount.toString(), ") zostały usunięte z systemu"));

                } else {
                  if (this.selectedReports.length == 1)
                    this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                      "Wystąpił błąd! Raport ".concat(this.selectedReports[0].title, " został usunięte z systemu. Spróbuj jeszcze raz"));
                  else
                    this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                      "Wystąpił błąd! Raporty (".concat(this.selectedReports.length.toString(), ") nie zostały usunięte z systemu. Spróbuj jeszcze raz"));
                }
                this.selectedReports = [];
                this.deleteReportObj = undefined;
                this.deleteReport = false;
                this.singleReportDelete = false;
                this.headerCheckbox.forEach((element) => {
                    element.nativeElement.checked = false;
                });
            },
            (error) => {
              if (this.selectedReports.length > 0)
                this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                  "Wystąpił błąd! Raport ".concat(this.selectedReports[0].title, " nie został usunięte z systemu. Spróbuj jeszcze raz"));
              else
                this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                  "Wystąpił błąd! Raporty (".concat(this.selectedReports.length.toString(), ") nie zostały usunięte z systemu. Spróbuj jeszcze raz"));

              this.deleteReport = false;
            }
        );
    }
    openDeletePopup(reportId: string) {
        this.deleteReportObj = this.reportData.filter(obj => obj.id == reportId)[0];
        this.deleteReport = true;
        this.singleReportDelete = true;
    }
    multipleReportDelete() {
        this.deleteReport = true;
        this.singleReportDelete = false;
    }
    modifySetsToAssignToReportSelected(set : Set) {
        let setPostion : number = this.setsToAssignToReportSelected.indexOf(set);
        if (setPostion == -1) {
            this.setsToAssignToReportSelected.push(set);
        } else {
            this.setsToAssignToReportSelected.splice(setPostion, 1);
        }
    }
    openAddToSets() {
        this.reportService.getSets("name ASC").subscribe(
            response => {
                if (response.status !== 1) {
                    this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: Nie pobrano listy zestawów");
                } else {
                    this.setsToAssignToReport = response.record;
                    this.showAddToSetPopup = true;
                }
            },
            error => {
                console.log(error);
                this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd w trakcie pobierania listy zestawów");
            }
        );
    }

    openCreateSetFromSelectedReports() {
      this.reportService.getSets("name ASC").subscribe(
        response => {
          if (response.status !== 1) {
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: Nie pobrano listy zestawów");
          } else {
            this.setsToAssignToReport = response.record;
            this.fillSetsToAssignReportsFromMoreLess();
            // alert(this.setsToAssignToReportMoreLess);
            this.currentCreateStep = CreateSetStep.Definition;
          }
        },
        error => {
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd w trakcie pobierania listy zestawów");
        }
      );
    }

    closeCreateSetFromSelectedReports() {
      this.setsToAssignToReportSelected=[];
      this.setsToAssignToReportMoreLess = [];
      this.selectedReports = [];
      this.currentCreateStep = null;
    }

    closeAddToSets() {
        this.setsToAssignToReportSelected=[];
        this.selectedReports = [];
        this.showAddToSetPopup = false;
        this.isDelete = false;
    }


    addToSets() {
        let setsToAssignToReportResults : Array<Observable<BackendServiceResponse<string, Report>>> = [];
        let result : boolean = false;
        this.selectedReports.forEach(report=>{
          let setsToAssign : Array<Set> = [];
          if (report.sets && report.sets.length>0)
            setsToAssign = report.sets.concat(this.setsToAssignToReportSelected);
          else
            setsToAssign = this.setsToAssignToReportSelected;

          setsToAssignToReportResults.push(this.reportService.assignSets(report.id, setsToAssign));
        });

        forkJoin(setsToAssignToReportResults).subscribe((results : Array<BackendServiceResponse<string, Report>>)=>{
          results.forEach((response : BackendServiceResponse<string, Report> )=>{
            if (response.status!='OK') {
              if (this.setsToAssignToReportSelected.length === 1)
                this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                  "Wystapił błąd!. Raporty (".concat(this.selectedReports.length.toString(), ") nie zostały dodane do zestawu ", this.setsToAssignToReportSelected[0].name, ". Spróbuj jeszcze raz"));
              else
                this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                  "Wystapił błąd!. Raporty (".concat(this.selectedReports.length.toString(), ") nie zostały dodane do wskazanych zestawów (", this.setsToAssignToReportSelected.length.toString(), "). Spróbuj jeszcze raz"));
            } else {
              result = true;
            }
          });
          if (results) {
            if (this.setsToAssignToReportSelected.length === 1)
              this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                "Raporty (".concat(this.selectedReports.length.toString(), ") zostały poprawnie dodane do zestawu ", this.setsToAssignToReportSelected[0].name));
            else
              this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                "Raporty (".concat(this.selectedReports.length.toString(), ") zostały poprawnie dodane do wskazanych zestawów (", this.setsToAssignToReportSelected.length.toString(), ")."));

            this.filterRecords();
          }

          this.closeAddToSets();
        });
    }

    private openEditReport(reportId : string) {
      this.reportService.getReport(reportId).subscribe(
        result=>{
          if (result.status !== 1)
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: Nie pobrano danych raportu");
          else {
            if (result.record.length == 0)
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Nie znaleziono raportu o id: ".concat(reportId));
            else {
              this.reportToEdit = result.record[0];
              if (this.reportToEdit.demoDisabled !== undefined) {
                  this.demoDisabled = this.reportToEdit.demoDisabled;
                  this.groupsToAssignSelected = [];
                  for (let i = 0; i < this.reportToEdit.excluded_from_groups.length; i++)
                      this.groupsToAssignSelected.push(this.reportToEdit.excluded_from_groups[i].id)
              } else {
                  this.demoDisabled = false;
              }
              this.contentTypeToAssignSelected = this.reportToEdit.content_type.id;

              this.editReportForm = new FormGroup({
                title : new FormControl(this.reportToEdit.title, Validators.required),
                description : new FormControl(this.reportToEdit.description),
                contentType : new FormControl(this.contentTypeToAssignSelected),
                reportFileToUpload : new FormControl(),
                demoFileToUpload : new FormControl(),
                publishFromDate: new FormControl()
              });


              this.reportToEdit.thematics_products.forEach((product)=>{
                this.productsToAssignSelected.push(product.id);
              });
              this.reportToEdit.thematics_institution.forEach((institution)=>{
                this.institutionsToAssignSelected.push(institution.id);
              });
              this.reportToEdit.thematics_client_groups.forEach((clientGroup)=>{
                this.clientGroupsToAssignSelected.push(clientGroup.id)
              });
              this.reportToEdit.thematics_area.forEach((area)=>{
                this.areaToAssignSelected.push(area.id);
              });
              this.reportToEdit.thematics_frequency.forEach((frequency)=>{
                this.frequencyToAssignSelected.push(frequency.id)
              });
              this.showEditReportPopup = true;
            }
          }
        },
        error=>{
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd w trakcie pobierania listy raportów")
        });
    }

    private closeEditReport() {
        this.showEditReportPopup = false;
        this.showGroupsSection = false;
        this.reportToEdit = null;
        this.frequencyToAssignSelected = [];
        this.areaToAssignSelected = [];
        this.clientGroupsToAssignSelected = [];
        this.productsToAssignSelected = [];
        this.institutionsToAssignSelected = [];
        this.groupsToAssignSelected = [];
        this.contentTypeToAssignSelected = null;
    }

    private getDictionaries() {
      forkJoin(
        this.commonService.getAreaDictionary(),
        this.commonService.getClientGroupsDictionary(),
        this.commonService.getContentTypeDictionary(),
        this.commonService.getFrequencyDictionary(),
        this.reportService.getInstitutionDictionary(),
        this.commonService.getInstitutionDictionary(),
        this.commonService.getProductsDictionary(),
        this.commonService.getGroupList('name ASC')
      ).subscribe(([areas, clientGroups, contentTypes, publicationFrequencies, institutions, institutionToAssignToSet, products, groups]) => {
          this.areaToAssign = areas;
          this.clientGroupsToAssign = clientGroups;
          this.contentTypeToAssign = contentTypes;
          this.frequencyToAssign =  publicationFrequencies;
          this.institutionsToAssign = institutions;
          this.institutionsToAssignToSet = institutionToAssignToSet;
          this.productsToAssign = products;
          this.groupsToAssign = groups.record;
        },
        (error) => {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Pojawił się błąd przy pobieraniu słowników");
          console.log("Błąd przy pobieraniu słowników:", JSON.stringify(error));
        });
    }

    private modifyAttributesSelected(attributeId : number, attributesSelectedList : Array<number>) {
      let elementPosition = attributesSelectedList.indexOf(attributeId);
      if (elementPosition == -1)
        attributesSelectedList.push(attributeId);
      else
        attributesSelectedList.splice(elementPosition, 1);
    }

    private modifySetsToAssignReportFromVisibility(){
      this.setsToAssignReportsVisibility = !this.setsToAssignReportsVisibility;
      if (!this.setsToAssignReportsVisibility) {
        this.setsToAssignToReport= [];
      }
    }

    private modifyShowContentTypeSection() {
        this.showContentTypeSection = !this.showContentTypeSection;
    }

    private modifyShowProductsSection() {
        this.showProductsSection = !this.showProductsSection;
    }

    private modifyShowGroupsSection() {
        this.showGroupsSection = !this.showGroupsSection;
    }

    private modifyShowInstitutionsSection() {
        this.showInstitutionsSection = !this.showInstitutionsSection;
    }

    private modifyShowClientGroupsSection() {
        this.showClientGroupsSection = !this.showClientGroupsSection;
    }

    private modifyShowAreaSection() {
        this.showAreaSection = !this.showAreaSection;
    }

    private modifyShowFrequencySection() {
        this.showFrequencySection = !this.showFrequencySection;
    }

    private modifyShowCancelPublish() {
        this.showCancelPublish = !this.showCancelPublish
    }

    private modifyPlannedPublishDate() {
        if(!this.showPublishFrom) {
            this.showPublishFrom = !this.showPublishFrom;
        }
  }

    private unpublishReport(report : Report) {
      this.reportService.unpublishReport(report.id).subscribe(
        result=>{
          if (result.status != 'OK') {
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
              "Wystąpił błąd! Publikacja raportu ".concat(report.title, " nie została cofnięta. Spróbuj jeszcze raz"));
          } else {
            this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
              "Publikacja raportu ".concat(report.title, " została cofnięta. Raport nie jest teraz widoczny dla użytkowników"));
            this.showCancelPublish = false;
            this.reportToEdit.published = false;

            this.filterRecords();

          }
        },
        error=>{
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Publikacja raportu ".concat(report.title, " nie została cofnięta. Spróbuj jeszcze raz"));

          console.log(error);
        })
    }
    public checkReportNotPublished(publishFrom):boolean {
        if(!publishFrom ) {
            return true;
        }
        return false;
    }

    public checkPublishFromNow(publishFrom):boolean {
        if(publishFrom ){
            let date = new Date();
            let pfDate = new Date(Date.parse(publishFrom));
            if(pfDate>date){
                return true;
            }else {
                return false;
            }
        }
    }
    
    private updateReport() {
      let publishFromDate : Date = undefined;      
      let reportId = this.reportToEdit.id;
        let dataToUpdate:any = {
          id : this.reportToEdit.id,
          title : this.editReportForm.controls['title'].value,
          description : this.editReportForm.controls['description'].value,
          content_type : this.editReportForm.controls['contentType'].value,
          thematics_products : this.productsToAssignSelected,
          thematics_institution : this.institutionsToAssignSelected,
          thematics_client_groups : this.clientGroupsToAssignSelected,
          thematics_area : this.areaToAssignSelected,
          thematics_frequency : this.frequencyToAssignSelected,
          demoDisabled: this.demoDisabled,
          excluded_from_groups: this.groupsToAssignSelected
        };

        this.reportService.updateReportFromReports(dataToUpdate).subscribe(
            result => {
                if (result.status != 'OK') {
                    this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                        "Wystąpił błąd! Informacje o raporcie ".concat(dataToUpdate.title, " nie zostały zmienione. Spróbuj jeszcze raz"));
                } else {
                    this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                        "Informacje o raporcie ".concat(dataToUpdate.title, " zostały zaktualizowane"));

                }
                if (this.editReportForm.controls['publishFromDate'].value && this.showPublishFrom == true) {
                    this.publishFrom = this.editReportForm.controls['publishFromDate'].value;
                    publishFromDate = new Date(this.publishFrom.year, this.publishFrom.month - 1, this.publishFrom.day);
                    this.reportService.publishReport(reportId, publishFromDate, false).subscribe(
                        result => {
                                this.filterRecords();
                        });
                }

            },

            error => {
                this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                    "Wystąpił błąd! Informacje o raporcie ".concat(dataToUpdate.title, " nie zostały zmienione. Spróbuj jeszcze raz"));

                console.log(error);
            }
        );

      this.closeEditReport();
    }

    private getReportList() {
      let httpParams = new HttpParams().set('sortString', this.createSortString());

      this.reportService.getReportList(httpParams).subscribe(res => {
        this.reportData = res["record"];
        if (!this.reportData.length) {
          this.headerCheckbox.forEach((element) => {
            element.nativeElement.checked = false;
          });
        }
        this.filteredReportCount = res.record.length;
        this.reportData = this.reportData.map(response => {
          response.isOpen = false;
          return response;
        });
        this.setPage(this.currentPage);
      });
    }

  orderByClick(orderByField : string) {
    if (orderByField === this.orderByField)
      this.orderAsc = !this.orderAsc;
    else {
      this.orderAsc = true;
      this.orderByField = orderByField;
    }

    this.filterRecords();
  }

  private createSortString() : string {
    let sortString = '';
    if (this.orderAsc)
      sortString = this.orderByField.concat(" ASC");
    else
      sortString = this.orderByField.concat(" DESC");

    return sortString;
  }

  private showPublishReport(report : Report) {
    this.reportToPublish = report;
    this.showPublish = true;
  }

  private hidePublishReport() {
    this.showPublish = false;
    this.publishFrom = null;
    this.reportToPublish = null;
    this.publicationType = PublicationType.PUBLISH_IMMEDIATE;
  }

  private publishReport() {
    let publishFromDate : Date = undefined;
    let publishImmediate : boolean = true;

    if (this.publishFrom) {
      publishFromDate = new Date(this.publishFrom.year, this.publishFrom.month-1, this.publishFrom.day);
    }
    if (this.publicationType === PublicationType.POSTPONE_TILL_DATE)
      publishImmediate = false;

    this.reportService.publishReport(this.reportToPublish.id, publishFromDate, publishImmediate).subscribe(
      result => {
          if (result.status == 'OK') {
            if (publishImmediate)
              this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                "Raport ".concat(this.reportToPublish.title, " został opublikowany"));
            else {
              this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                "Publikacja raportu ".concat(this.reportToPublish.title, " została zaplanowana na ", publishFromDate.toLocaleDateString('pl-PL'), "r."));
            }

            this.filterRecords();

          } else
            if (publishImmediate)
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                "Wystąpił błąd! Raport ".concat(this.reportToPublish.title, " nie został opublikowany. Spróbuj jeszcze raz"));
            else
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                "Wystąpił błąd! Publikacja raportu".concat(this.reportToPublish.title, " nie została zaplanowana. Spróbuj jeszcze raz"));

        this.hidePublishReport()
      },
      error => {
        if (publishImmediate)
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Raport ".concat(this.reportToPublish.title, " nie został opublikowany. Spróbuj jeszcze raz"));
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Publikacja raportu".concat(this.reportToPublish.title, " nie została zaplanowana. Spróbuj jeszcze raz"));

        this.hidePublishReport();
      }
    )
  }

  private onChangePublicationType() {
    switch (this.publicationType) {
      case PublicationType.PUBLISH_IMMEDIATE: {
        this.showPublishFrom = false;
        this.publishFrom = undefined;
        break;
      }
      case PublicationType.POSTPONE_TILL_DATE: {
        this.showPublishFrom  = true;
        break;
      }
    }
  }

  private fillSetsToAssignReportsFromMoreLess() {
    if (this.setsToAssignToReportMoreLess.length < this.setsToAssignToReport.length) {
      this.setsToAssignToReportMoreLess = this.setsToAssignToReport.slice();
    } else {
      this.setsToAssignToReportMoreLess = this.setsToAssignToReport.slice(0, this.MORE_LESS_LIMIT-1);
    }
  }

  private setsToAssignReportsFromMoreLessClick() {
      this.fillSetsToAssignReportsFromMoreLess();
  }

  private createSetNextStep() : void {

    this.reportIdsToAssignToSetSelected = [];
    let setsToLookForReports : Array<number>;

    setsToLookForReports = this.setsToAssignToReportSelected.map(set=>set.id);

    let setName = this.createSetForm.controls['setName'].value;
    this.commonService.setExists(setName).subscribe(
        response => {
            if (response.status != 1)
                this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                    "Wystąpił błąd! Nie można sprawdzić, czy zestaw o podanej nazwie istnieje");
            else
            if (response.message)
                this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                    "Zestaw z daną nazwą już istnieje w serwisie");
            else
                this.setService.getReportsBySetIds(setsToLookForReports).subscribe(
                    response =>{
                        if (response.status !=='OK')
                            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd: Nie można pobrać listy raportów dla wskazanych zestawów")
                        else {
                            this.setNameForDisplayOnStepTwo = this.createSetForm.controls['setName'].value;
                            this.reportsToAssignToSets = response.record;

                            //Raporty wskazane przez usera na lisćie raportów
                            let tmpReportIdsToAssignToSets : Array<number>;
                            tmpReportIdsToAssignToSets  = this.reportsToAssignToSets.map(report=>report.id);

                            this.selectedReports.forEach(report=>{
                                if (tmpReportIdsToAssignToSets.indexOf(report.id)==-1)
                                    this.reportsToAssignToSets.push(report);
                            });

                            //Raporty pochodzące z zestawów wskazanych przez usera w pierwszym kroku
                            this.reportsToAssignToSets.forEach((report : Report) => {
                                if (this.reportIdsToAssignToSetSelected.indexOf(report.id)==-1)
                                    this.reportIdsToAssignToSetSelected.push(report.id);
                            });

                            this.currentCreateStep = CreateSetStep.ReportsFromSets;
                        }
                    },
                    error => {
                        console.log(error);
                        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd: Nie można pobrać listy raportów dla wskazanych zestawów");
                    }
                )
        },
        error => {
            console.log(error);
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                "Wystąpił błąd! Nie można sprawdzić, czy zestaw o podanej nazwie istnieje");
        }
    );
  }

  private createSetPreviousStep() : void {
    this.currentCreateStep = CreateSetStep.Definition;
  }

  private createSet() : void {
      let setParameters = {};

      let setName: string = this.createSetForm.controls['setName'].value;
      setParameters['name'] = setName;

      //Jesli przechodzimy od razu do tworzenia zestawu
      if (this.currentCreateStep == CreateSetStep.Definition)
          this.reportIdsToAssignToSetSelected = this.selectedReports.map(report => report.id);

      if (this.contentTypeToAssignToSetSelected.length > 0)
          setParameters['contentTypes'] = this.contentTypeToAssignToSetSelected;

      if (this.productsToAssignSelected.length > 0)
          setParameters['thematics_products'] = this.productsToAssignSelected;

      if (this.institutionsToAssignSelected.length > 0)
          setParameters['thematics_institution'] = this.institutionsToAssignSelected;

      if (this.clientGroupsToAssignSelected.length > 0)
          setParameters['thematics_client_groups'] = this.clientGroupsToAssignSelected;

      if (this.areaToAssignSelected.length > 0)
          setParameters['thematics_area'] = this.areaToAssignSelected;

      if (this.frequencyToAssignSelected.length > 0)
          setParameters['thematics_frequency'] = this.frequencyToAssignSelected;

      if (this.reportIdsToAssignToSetSelected.length > 0)
          setParameters['reports'] = this.reportIdsToAssignToSetSelected;

      this.commonService.setExists(setName).subscribe(
          response=>{
              if (response.status != 1)
                  this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                      "Wystąpił błąd! Nie można sprawdzić, czy zestaw o podanej nazwie istnieje");
              else
                  if (response.message)
                      this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                          "Zestaw z daną nazwą już istnieje w serwisie");
                  else {
                      this.setService.createSet(setParameters).subscribe(
                          response => {
                              if (response.status == '1') {
                                  this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                                      "Zestaw " + setName + " raportów został poprawnie dodany.");

                                  this.filterRecords();
                              } else {
                                  this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                                      "Wystąpił błąd! Zestaw " + setName + " raportów nie został dodany. Spróbuj jeszcze raz.");
                                  console.log(response);
                              }
                          },
                          error => {
                              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                                  "Wystąpił błąd! Zestaw " + setName + " raportów nie został dodany. Spróbuj jeszcze raz.");
                              console.log(error);
                          }
                      );
                      this.selectedReports = [];
                      this.reportIdsToAssignToSetSelected = [];
                      this.contentTypeToAssignToSetSelected = [];
                      this.productsToAssignSelected = [];
                      this.institutionsToAssignSelected = [];
                      this.clientGroupsToAssignSelected = [];
                      this.areaToAssignSelected = [];
                      this.frequencyToAssignSelected = [];

                      this.currentCreateStep = null;
                  }
          },
          error=>{
              console.log(error);
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                  "Wystąpił błąd! Nie można sprawdzić, czy zestaw o podanej nazwie istnieje");
          }
      );
  }
  private downloadReportClick(report : Report) {
    this.commonService.downloadReportFile(report.id).subscribe(
      data=> {
        saveAs(data, report.fileName);
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie można pobrać wskazanego raportu");
      }
    )

  }

  private downloadDemoClick(report : Report) {
      this.commonService.downloadDemoFile(report.id).subscribe(
        data => {
          saveAs(data, report.demoFileName);
        },
        err => {
          console.log(err);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie możńa pobrać demow wskazanego raportu");
        }
      )
  }

  replaceDemoFile(event: any, reportId : string): void {
    if (event.target.files.length > 0)
      this.reportService.uploadDemoFile(event.target.files[0], reportId).subscribe(
        response => {
          if (response.record.length > 0)
            this.reportToEdit.demoFileName = response.record[0].demoFileName;
            this.reportToEdit.repositoryDemoFileName = response.record[0].repositoryDemoFileName;
            this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Plik z DEMO tego raportu został podmieniony")

        },
        err => {
          console.log(err);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie można zmienić DEMO tego raportu");
        }
      );
  }

  replaceReportFile(event : any, reportId : string) : void {
      if (event.target.files.length > 0) {
        this.reportService.replaceReportFile(event.target.files[0], reportId).subscribe(
          response => {
            if (response.status != 1)
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                "Wystąpił błąd! Nie można zmienić pliku raportu");
            else if (response.record.length > 0) {
              this.reportToEdit.fileName = response.record[0].fileName;
              this.reportToEdit.repositoryFileName = response.record[0].repositoryFileName;
              this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                "Plik z raportem został podmieniony")
            }
          },
          err => {
            console.log(err);
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
              "Wystąpił błąd! Nie można zmienić pliku raportu");
          }
        );
        event.target.files = [];
      }
  }
}
